import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Main from '../views/Main.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/main'
  },
  // {
  //   path: '/login',
  //   name: 'Login',
  //   component: Login
  // },
  {
    path: '/main',
    name: 'Main',
    component: Main,
    meta: { requiresAuth: true } // 标识需要登录拦截
  }
]

const router = new VueRouter({
 mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 全局前置路由守卫：防止未登录直接修改 URL 访问 /main
// router.beforeEach((to, from, next) => {
//   const token = sessionStorage.getItem('token')
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     if (!token) {
//       // 未登录，强制跳转回登录页
//       next({ path: '/login' })
//     } else {
//       next()
//     }
//   } else {
//     next()
//   }
// })

router.beforeEach((to, from, next) => {
  next() // 直接放行所有路由
})
export default router